import { useEffect } from "react";
import { useSignal, signal } from "@preact/signals-react";

import { Alert } from "componentsv2/widgets/Alert";
import { useContext } from "../store/useContext";
import BoardForm from "componentsv2/form/BoardForm";
import { layout as layoutSchedule } from "../models/ModelSchedule";

export const alertMsg = signal({
  show: false,
  text: null,
  icon: "check",
  color: "bg-green-200",
  autoRemove: true,
});

const Schedule = ({ onChangeView }) => {
  const { context } = useContext();
  const { currentEvent } = context;
  const _layoutSchedule = layoutSchedule();
  const recordStoreId = useSignal(currentEvent?.storeId ?? null);

  function handleView(action, recStoreId) {
    if (action === "edit") {
      recordStoreId.value = recStoreId;
    } else if (action === "return") {
      recordStoreId.value = currentEvent?.storeId ?? null;
      if (onChangeView) onChangeView(action);
    }
  }

  function handleClose() {
    if (onChangeView) onChangeView("return");
  }

  useEffect(() => {
    if (currentEvent?.storeId) {
      recordStoreId.value = currentEvent.storeId;
    }
    alertMsg.value = { ...alertMsg.value, show: false };

    return () => {
      alertMsg.value = { ...alertMsg.value, show: false };
    };
  }, [currentEvent?.storeId]);

  if (!recordStoreId.value) return null;

  return (
    <div className="h-full w-full p-4">
      <Alert
        {...alertMsg.value}
        onClose={() => (alertMsg.value = { ...alertMsg.value, show: false })}
      />
      <BoardForm
        layout={_layoutSchedule}
        storeId={recordStoreId.value}
        handleView={handleView}
        onClose={handleClose}
        title={true}
        closeOnChangeView
      />
    </div>
  );
};

export default Schedule;
